export default __webpack_public_path__ + "static/media/portfolio-sm.457e3d84.webp";